export default class BaseService {
  constructor(ctx) {
    this.ctx = ctx;
    this.$http = ctx.$axios;
    this.$store = ctx.store;
    this.$router = ctx.router;
  }
}
